import React, { Component } from "react";
//import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import { compose } from 'react-apollo';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import withQuery from 'containers/withQuery';
import styled from 'styled-components';
import {media} from 'styled-bootstrap-grid';





//const AnyReactComponent = ({ text }) => <div>{text}</div>;


const Wrapper = styled.div`
width: 100%;
height: 50vh;
padding: 0px;
margin: auto;

${media.xl`
    width: 50%;
`}

`;


class Map extends Component {
    constructor(props) {
        super(props)

        this.state = {
            lat: null,
            locations: []
        };
    }

    static defaultProps = {
        center: {
            lat: 56.1629,
            lng: 10.2039
        },
        zoom: 3
    }

    componentDidMount() {
    }

    //Remove http or https from displayed location's url for aesthetic purposes
    removeHttp(x) {
        if (x.slice(0, 5) === "https") {
            x = x.slice(8);
            return x
        }
        else {
            x = x.slice(7)
            return x
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.optionsLocations) {
            if (!prevProps.optionsLocations || this.props.optionsLocations.locations !== prevProps.optionsLocations.locations) {
                this.setState({ locations: this.props.optionsLocations.locations })
            }
        }
    }

    render() {
        if (!this.props.optionsLocations) return null
        const { center, zoom, lat, lng, country } = this.props
        //console.log('hmmm')

        return (
            <Wrapper>

                {/*  <div style={{ height: '100%', width: '100%' }}>
                    <GoogleMapReact
                        bootstrapURLKeys={{ key: "" }}
                        defaultCenter={this.props.center}
                        defaultZoom={this.props.zoom}
                    >
                        {this.state.locations && this.state.locations.map((location) => {
                            if(location.lat && location.lng !== "") {
                                return (
                                    <Marker
                                        lat={location.lat}
                                        lng={location.lng}
                                        title={location.title}
                                        address={location.address}
                                        zip={location.zip}
                                        phone={location.phone}
                                        mail={location.mail}
                                        url={this.removeHttp(location.url)}
                                    />
                                )
                            }
                            
                        })}
                    </GoogleMapReact>
                </div>  */}
            </Wrapper>
        )
    }
}

export default compose(
    withRouter,

    withQuery(() => gql`
      {
        optionsLocations {
          locations {
            country
            title
            address
            zip
            phone
            mail
            region
            url
            img {
              sourceUrl
            }
            lat
            lng
          }
        }
      }
    `, 'optionsLocations')
)(Map)


// WEBPACK FOOTER //
// ./src/ui/components/modules/Map/index.js